// extracted by mini-css-extract-plugin
module.exports = {"checkboxes":"style_checkboxes__PIqYc","link":"style_link__r700D"};